"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserServiceLive = void 0;
const mystake_common_sdk_1 = require("@boulevard1/mystake-common-sdk");
const HttpProvider_1 = require("../utils/HttpProvider");
const constants_1 = require("../utils/constants");
class UserServiceLive {
    isNominee() {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get("/user/is-nominee");
            return (_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.payload) !== null && _b !== void 0 ? _b : { isNominee: false, nomineeForCompanyIds: [] };
        });
    }
    updateKycDoneStatus() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.patch("/user/kycstatus");
            return response.data.status;
        });
    }
    getUser() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(constants_1.GET_USER);
            if (!((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.payload)) {
                throw new Error("Failed to get user profile");
            }
            return response.data.payload;
        });
    }
    getUserById(userId) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/user/${userId}/get-user-by-id`);
            if (!((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.payload)) {
                throw new Error("Failed to get user profile");
            }
            return response.data.payload;
        });
    }
    updateUserPrimaryPhone(phoneDetails) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.patch(constants_1.UPDATE_PRIMARY_PHONE, Object.assign({}, phoneDetails));
            if (!((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.payload)) {
                return false;
            }
            return response.data.payload.status || false;
        });
    }
    isEmailExists(email) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.post(constants_1.EMAIL_EXISTS, {
                email,
            });
            if (!((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.payload)) {
                return false;
            }
            return response.data.payload.emailExists || false;
        });
    }
    isAcnExists(acn) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.post(constants_1.ACN_EXISTS, {
                acn,
            });
            if (!((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.payload)) {
                return false;
            }
            return response.data.payload.acnExists || false;
        });
    }
    updateEmail(email) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.patch(constants_1.UPDATE_PRIMARY_EMAIL, { email });
            if (!((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.payload)) {
                throw new Error("Failed to update email");
            }
            return response.data.payload.newEmail || "";
        });
    }
    updateDobAddress(dobAddressData) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.patch("/user/pre-kyc", {
                birthDetails: {
                    dob: dobAddressData.dob,
                    birthPlace: "",
                    birthCountry: "",
                },
                kycDetails: {
                    isKYCDone: false,
                    address: {
                        description: dobAddressData.description,
                        flatNumber: dobAddressData.flatNumber || "",
                        streetNumber: dobAddressData.streetNumber,
                        propertyName: dobAddressData.propertyName,
                        streetName: dobAddressData.streetName,
                        suburb: dobAddressData.suburb,
                        townCity: dobAddressData.townCity,
                        city: dobAddressData.city,
                        postcode: dobAddressData.postcode,
                        state: dobAddressData.state,
                        country: dobAddressData.country,
                    },
                    verificationId: "",
                    verificationToken: "",
                },
            });
            return response.data.status;
        });
    }
    removePreKycDetails() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.patch("/user/remove-pre-kyc");
            return response.data.payload;
        });
    }
    // eslint-disable-next-line consistent-return
    updateKycDetails(updateKycDetailsData) {
        return __awaiter(this, void 0, void 0, function* () {
            if (updateKycDetailsData) {
                const response = yield HttpProvider_1.httpProvider.patch("/user/pre-kyc", {
                    birthDetails: {
                        dob: updateKycDetailsData.dob,
                        birthPlace: "",
                        birthCountry: "",
                    },
                    kycDetails: {
                        isKYCDone: updateKycDetailsData.isKYCDone,
                        address: updateKycDetailsData.address,
                        verificationId: updateKycDetailsData.verificationId,
                        verificationToken: updateKycDetailsData.verificationToken,
                    },
                });
                return response.data.status;
            }
            return false;
        });
    }
    updateAddressDetails(updateAddressDetailsData) {
        return __awaiter(this, void 0, void 0, function* () {
            if (updateAddressDetailsData) {
                const response = yield HttpProvider_1.httpProvider.patch("/user/address", {
                    careOf: updateAddressDetailsData.careOf,
                    line2: updateAddressDetailsData.line2,
                    street: updateAddressDetailsData.street,
                    locality: updateAddressDetailsData.locality,
                    state: updateAddressDetailsData.state,
                    postcode: updateAddressDetailsData.postcode,
                    country: updateAddressDetailsData.country,
                });
                return response.data.status;
            }
            return false;
        });
    }
    requestPasswordReset(requestPasswordResetRequestBody) {
        return __awaiter(this, void 0, void 0, function* () {
            // eslint-disable-next-line no-return-await
            const response = yield HttpProvider_1.httpProvider.post("/user/forgot-password", requestPasswordResetRequestBody);
            return response.data;
        });
    }
    setNewPassword(authToken, setNewPasswordRequestBody) {
        return __awaiter(this, void 0, void 0, function* () {
            const headers = { authorization: `Bearer ${authToken}` };
            // eslint-disable-next-line no-return-await
            const response = yield HttpProvider_1.httpProvider.post("/user/set-password", setNewPasswordRequestBody, headers);
            return response.data;
        });
    }
    verifyThenUpdateMobileNumber(verifyThenUpdateMobileNumberRequestBody) {
        return __awaiter(this, void 0, void 0, function* () {
            // eslint-disable-next-line no-return-await
            const response = yield HttpProvider_1.httpProvider.post("/user/phones/verify-and-update", verifyThenUpdateMobileNumberRequestBody);
            return response.data;
        });
    }
    linkNomineeExistingAccount(linkNomineeExistingAccountRequestBody) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.post("/nominee/link-existing-account", linkNomineeExistingAccountRequestBody);
            return response.data;
        });
    }
    updateLastLogin(username) {
        return __awaiter(this, void 0, void 0, function* () {
            if (username) {
                const response = yield HttpProvider_1.httpProvider.patch("/user/last-login", {
                    username,
                });
                return response.data.status;
            }
            return false;
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getUserCompanies(page, pageSize, sortField) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/user/profile/companies?page=${page}&pageSize=${pageSize}&sortField=${sortField}`);
            return response.data;
        });
    }
    grantShareholderRole(companyId, role) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.post("/user/grant-access", {
                companyId,
                role,
            });
            return response.data.payload;
        });
    }
    getInvestorProfiles(companyId, filterByCompany = false, status = [mystake_common_sdk_1.ShareholderStatus.ACCEPTED], keyword, page, rowsPerPage, sortBy, sortOrder) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield HttpProvider_1.httpProvider.get(`/user/investors?companyId=${companyId}&filterByCompany=${filterByCompany}&status=${status}&page=${page}&rowsPerPage=${rowsPerPage}&sortBy=${sortBy}&sortOrder=${sortOrder}&keyword=${keyword}`);
            return response.data;
        });
    }
}
exports.UserServiceLive = UserServiceLive;
//# sourceMappingURL=UserServiceLive.js.map